// extracted by mini-css-extract-plugin
module.exports = {"container":"about-module--container--1Z2Hg","headline":"about-module--headline--TpfAZ","column":"about-module--column--1PsSJ"};